// removed by extract-text-webpack-plugin
module.exports = {"report-chart":"report-chart","report-chart-title":"report-chart-title","report-chart-title-number":"report-chart-title-number","chart-sub-title":"chart-sub-title","chart-sub-tag":"chart-sub-tag","report-chart-buttons":"report-chart-buttons","report-chart-count":"report-chart-count","active":"active","report-chart-size":"report-chart-size","report-chart-report":"report-chart-report"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/ReportChart/Index.scss
// module id = 922
// module chunks = 0